import React from "react";

import { bondArchivesEndorsementDialogPropTypes } from "./bondEndorsementDialogPropTypes";
import BondEndorsementDialog from "./BondEndorsementDialog";

/** Thin wrapper — archives call sites keep legacy prop names. */
export default function BondArchivesEndorsementDialog(props) {
  return <BondEndorsementDialog variant="archives" {...props} />;
}

BondArchivesEndorsementDialog.propTypes = bondArchivesEndorsementDialogPropTypes;
